@if (tableConfig.locks) {
  <div class="actions-bar" data-id="actionBarLocks">
    @if (
      lockService.isEntryLocked(data) &&
      lockService.isEntryLockedByCurrentAdmin(data) &&
      tableConfig.commands.length > 0
    ) {
      <span [matMenuTriggerFor]="menu" data-id="rowMenu">
        <i class="fas fa-ellipsis-v"></i>
      </span>
    }
    @if (!lockService.isEntryLocked(data) && tableConfig.commands.length > 0) {
      <span (click)="lockTicker()" data-id="rowMenuUnlock">
        <i class="fas fa-lock"></i>
      </span>
    }
    @if (
      lockService.isEntryLocked(data) &&
      !lockService.isEntryLockedByCurrentAdmin(data) &&
      tableConfig.commands.length > 0
    ) {
      <span [matMenuTriggerFor]="menu" data-id="rowMenuImg">
        <img src="{{ data.locked.image }}" class="menu-image" />
      </span>
    }
  </div>
}

@if (!tableConfig.locks) {
  <div class="actions-bar" data-id="actionBarUnlocks">
    @if (tableConfig.commands.length > 0) {
      <span [matMenuTriggerFor]="menu" data-id="rowMenu">
        <i class="fas fa-ellipsis-v"></i>
      </span>
    }
  </div>
}

<mat-menu #menu="matMenu">
  @for (action of extractActions(); track action) {
    <button type="button" mat-menu-item (click)="sendCommand(action.command)">
      @if (action.icon) {
        <span class="info-icon">
          <i class="fas fa-{{ action.icon }}"></i>
        </span>
      }
      <span [attr.data-id]="'menu_' + action.buttonLabel">{{ action.buttonLabel }}</span>
    </button>
  }
</mat-menu>
